import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const GroupDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Group"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Group Name">
                {getFieldDecorator('name', {
                 initialValue: data.name,
                  rules: [{ required: true, message: 'Please input the Group Name!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default GroupDialogForm;
